import { Facebook, Linkedin } from 'lucide-react';
import Logo from '../assets/images/Logo';
import BatAnimation, { type BatAnimationConfig } from './BatAnimation';
import SocialLinks, { type SocialLinkConfig } from './SocialLinks';
import StarField from './StarField';
import './Home.scss';
import { XIcon } from '@/assets/icons/Xtwitter';

// Configuration data
const batAnimations: BatAnimationConfig[] = [
	{
		id: 'bat-1',
		className: 'bat-1',
		position: { top: '5rem', left: '2.5rem' },
		width: '80px',
		height: '80px'
	},
	{
		id: 'bat-2',
		className: 'bat-2',
		position: { top: '10rem', right: '5rem' },
		delayClass: 'delay-100',
		width: '80px',
		height: '80px'
	},
	{
		id: 'bat-3',
		className: 'bat-3',
		position: { bottom: '8rem', left: '25%' },
		delayClass: 'delay-200',
		width: '80px',
		height: '80px'
	},
	{
		id: 'bat-4',
		className: 'bat-4',
		position: { top: '33.333333%', right: '25%' },
		delayClass: 'delay-150',
		width: '80px',
		height: '80px'
	}
];

const socialLinks: SocialLinkConfig[] = [
	{
		id: 'facebook',
		href: 'https://www.facebook.com/NaveW',
		icon: Facebook,
		label: 'Facebook',
		target: '_blank',
		rel: 'noopener noreferrer'
	},
	{
		id: 'twitter',
		href: 'https://x.com/navecave',
		icon: XIcon,
		label: 'Twitter',
		target: '_blank',
		rel: 'noopener noreferrer'
	},
	{
		id: 'linkedin',
		href: 'https://www.linkedin.com/in/nave-weinberg-39001798/',
		icon: Linkedin,
		label: 'LinkedIn',
		target: '_blank',
		rel: 'noopener noreferrer'
	}
];

const SHOW_SOCIAL = false;

export default function Home() {
	return (
		<main className="min-h-screen flex flex-col items-center justify-center px-4 py-12 relative overflow-hidden night-sky-gradient pointer-events-none select-none">
			{/* Twinkling stars */}
			<StarField count={30} />

			{/* Lottie bat animations with random movement */}
			<BatAnimation animations={batAnimations} />

			<div className="w-full max-w-sm text-center relative z-10">
				<div className="flex flex-col items-center">
					<Logo className="w-65 h-65" />
					<h2
						className="text-4xl text-white tracking-wider -mt-4"
						style={{ fontFamily: 'Amarante, serif' }}
					>
						WEINBERG
					</h2>
				</div>

				{SHOW_SOCIAL && <SocialLinks links={socialLinks} />}
			</div>

			<footer className="absolute bottom-4 w-full text-center">
				<p className="text-xs text-gray-300">&copy; {new Date().getFullYear()}</p>
			</footer>
		</main>
	);
}
